<script lang="ts">
	import { page } from '$app/stores';
	import type { SignUpStepData } from '$lib/types/form';
	import { getTranslate } from '@tolgee/svelte';
	import { createEventDispatcher } from 'svelte';
	import SelectionItem from '../SelectionItem.svelte';
	import SelectionList from '../SelectionList.svelte';

	const dispatch = createEventDispatcher();

	let { supabase } = $page.data;
	$: ({ supabase } = $page.data);
	$: console.log($page.data);
	const { t } = getTranslate();

	export let step: number;
	export let field: SignUpStepData['field'];
	export let options: SignUpStepData['options'];
	export let additionalClass = 'w-full';

	async function handleSelect(value: string) {
		const userId = $page.data.session?.user.id;
		try {
			if (!userId && value) throw 'error: no userId' + userId + ' or option ' + value;
			if (value === 'other') {
				dispatch('other');
				return;
			}
			await supabase
				.from('profiles')
				.update({ [field]: value })
				.eq('id', userId);
			dispatch('success');
		} catch (error) {
			dispatch('error', { error });
		}
	}
</script>

<div class="w-full">
	<h1 class="font-bold text-xl mb-4">
		{@html $t(`signup.step${step}.headline`)}
	</h1>
	<div
		class="grid grid-col items-center max-h-[420px] pr-5 gap-4 overflow-y-auto overflow-x-hidden"
	>
		<SelectionList listLength={options.length} {additionalClass}>
			{#each options as option, i}
				<SelectionItem
					additionalClass="w-[99%] !min-h-[80px] gap-11 mb-2 mx-4 mt-1"
					icon={option.id}
					title={option.title}
					data-test={`__signup-step-${step}-${option.id}`}
					on:select={() => handleSelect(option.id)}
				/>
			{/each}
		</SelectionList>
	</div>
</div>
